import { ordersActions } from "../../../_store/order.slice";
import { orderViewsActions } from "../../../_store/orderView.slice";
import { OrderWorkFlowAction } from "./OrderWorkFlowAction";
import { DomainSwitch } from "../../../_components/Abstractions/DomainSwitch";
import { TRANSACTION_TYPE } from "../../../domain/TransactionType";

export function CompleteCourseOrder({ orderId, orderNumber, transactionType, services }) {
  const successMessage = "Kurs został zrealizowany";
  const buttonText = "Zrealizuj kurs";
  const title = `Czy zrealizować kurs ${orderNumber}?`;
  const isTransport = transactionType === TRANSACTION_TYPE.TRANSPORT;
  const hasServices = services && services.length > 0;
  const formControls = <>
    <DomainSwitch name="skipServiceValidation" label="Potwierdź brak usług" />
  </>

  const props = {
    orderId: orderId,
    orderAction: ordersActions.completeCourse,
    orderViewAction: orderViewsActions.completeCourse,
    successMessage,
    buttonText,
    title,
    formControls,
    useFormModal: !isTransport && !hasServices
  };

  return <OrderWorkFlowAction {...props} />
}

